import React, { useRef } from "react";
import { esgScores, NARating } from "common/esg-helpers";
import { InsHighcharts } from "components/widgets/base/insHighcharts";
import { useSmartResizeObserver } from "components/workspaces/hooks/use-smart-resize-observer";
import "./insEsgRatingKPIChart.scss";
const getNARating = () => [
    {
        className: "",
        colorIndex: 0,
        name: NARating,
        y: 1
    }
];
const getEsgData = (selectedValue) => esgScores.slice().reverse()
    .map((value, index) => ({
    className: `highcharts-color-${index}-${value === selectedValue ? "selected" : "transparent"}`,
    colorIndex: index,
    name: value,
    y: 1
}));
const getSeriesData = (selectedValue) => (selectedValue === NARating ? getNARating() : getEsgData(selectedValue));
const chartHeightCorrectionMultiplier = 1.6;
const chartWidthCorrection = -4;
const horizontalChartHeightMultiplier = 0.77;
const varticalChartHeightMultiplier = 0.5;
const titleVerticalOffset = 28;
export const InsEsgRatingKPIChart = (props) => {
    const ref = useRef(null);
    const { height, width } = useSmartResizeObserver(ref, `${props.sectionId}.${props.widgetId}`);
    const isHorizontal = height < width;
    const horizontalSizeCorrection = 28;
    const bigChartSizeCorrection = -Math.max(height, width) * 0.03;
    const size = Math.min(height * chartHeightCorrectionMultiplier, width + chartWidthCorrection) + (isHorizontal ? horizontalSizeCorrection : 0) + bigChartSizeCorrection;
    const verticalPositionCorrection = -6;
    const halfDonutYCenter = (height * (isHorizontal ? horizontalChartHeightMultiplier : varticalChartHeightMultiplier)) + verticalPositionCorrection;
    const options = {
        chart: {
            className: "highchart-esg-kpi-rating-chart",
            plotShadow: false,
            spacing: [0, 10, 15, 10],
            style: { fontFamily: "inherit" },
            styledMode: true,
            type: "pie"
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            pie: {
                animation: false,
                center: ["50%", halfDonutYCenter],
                endAngle: 90,
                size,
                startAngle: -90
            }
        },
        series: [
            {
                data: getSeriesData(props.selectedValue) || [],
                dataLabels: {
                    enabled: false
                },
                enableMouseTracking: false,
                innerSize: "75%",
                type: "pie"
            }
        ],
        title: {
            align: "center",
            text: `<div class="div-title title ins-formatted-numeral">${props.selectedValue}</div>`,
            useHTML: true,
            verticalAlign: "middle",
            y: halfDonutYCenter - (height / 2) + titleVerticalOffset
        }
    };
    return React.createElement(InsHighcharts, { key: props.selectedValue, options: options, wrapperRef: ref, colorSet: "esgKpiWidget", sectionId: props.sectionId, widgetId: props.widgetId });
};
